<template>
<div class="chapter">
<div class="inner_page">
<p class="image5c"><a id="page_viii"><img alt="Image" height="142" src="images/ak.jpg" width="300"/></a></p><a id="page_viii">
<p class="noindent">The day Howard Books contacted me regarding publishing this book, the U.S. Navy Reserves mobilized my husband. He left a month later to spend more than a year in Iraq, leaving me with four kids and an incomplete manuscript. To say I owe a huge debt of gratitude to those who supported me would be a gross understatement.</p>
<p class="indent">Many thanks . . .</p>
<p class="indent">To God: for Your sense of timing, sense of humor, and unfailing love.</p>
<p class="indent">To Kevin: for your unwavering belief in me, your strength, and your willingness to sacrifice in order to serve others. You lead by example. I am proud to call you husband.</p>
<p class="indent">To my parents: for being my first editors and fans.</p>
<p class="indent">To my in-laws: for being there, cheerleading, and child care.</p>
</a><p class="indent"><a id="page_viii"></a><a id="page_ix">To my kids: for allowing me to write and “not work for you” for a season.</a></p><a id="page_ix">
<p class="indent">To my siblings: for early morning phone calls, frequent e-mails, and your prayers.</p>
<p class="indent">To Barbara and Liisa: for hanging in and hanging out with me. To the staff at Faith Church: for your incredible enthusiasm, grace, and dinner every Tuesday for a year! I am blessed to serve alongside you.</p>
<p class="indent">To Faith Writers: for your encouragement, critique, and companionship on this journey.</p>
<p class="indent">To my Faith Church family: for your prayers, kind deeds, and many meals.</p>
<p class="indent">To Write to Publish: for giving me knowledge and opportunity.</p>
<p class="indent">To Denny, Chrys, and the rest of the Howard Books family: for caring about my book and my family.</p>
<p class="indent">To Dawn at Between the Lines: for adding clarity to my vision for this project.</p>
</a><p><a id="page_ix"></a><a id="page_x"></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?0efa6e60